import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { isAnalyticsEnabled } from '../core/lib';

import {
	AMPLITUDE_EVENT,
	AMPLITUDE_PERISCOPE_EVENT_SOURCE,
	AmplitudeCustomerData,
	AmplitudeEvent,
	SonarAmplitudeWindow
} from './@types';
import { identify, Identify, init, track } from '@amplitude/analytics-browser';

declare const window: SonarAmplitudeWindow;

function isAmplitudeAnalyticsEnabled(): boolean {
	const { amplitude_api_key } = window.sonar;

	// eslint-disable-next-line camelcase
	return Boolean(amplitude_api_key) && isAnalyticsEnabled();
}

export function logAmplitudeEvent(event: AmplitudeEvent<Record<string, unknown> | undefined>): void {
	try {
		if (isAmplitudeAnalyticsEnabled()) {
			const { id, data } = event;

			track(id, data);
		}
	} catch (ex) {
		console.log('error logging to amplitude:', ex);
	}
}

export function initializeAmplitude(data: AmplitudeCustomerData): void {
	try {
		if (isAmplitudeAnalyticsEnabled()) {
			const { amplitude_api_key } = window.sonar;
			const { customer, email, orgCount, userCount } = data;
			const identity = new Identify()
				.set('customer', customer)
				.set('orgCount', orgCount)
				.set('userCount', userCount);

			init(amplitude_api_key, email, { includeReferrer: true });
			identify(identity);
		}
	} catch (ex) {
		console.log('error initializing amplitude:', ex);
	}
}

export function getAmplitudeRouteEventId(route: string): AMPLITUDE_EVENT | null {
	switch (route) {
	case FULL_ROUTES.DASHBOARD:
		return AMPLITUDE_EVENT.DASHBOARD_CLICKED;
	case FULL_ROUTES.INITIATIVES:
		return AMPLITUDE_EVENT.INITIATIVE_DASHBOARD_VIEWED;
	case FULL_ROUTES.ISSUES:
		return AMPLITUDE_EVENT.ISSUES_VIEWED;
	case FULL_ROUTES.SETTINGS:
		return AMPLITUDE_EVENT.SETTINGS_VIEWED;
	case FULL_ROUTES.TAGS:
		return AMPLITUDE_EVENT.TAGS_VIEWED;
	case FULL_ROUTES.TIMELINE:
		return AMPLITUDE_EVENT.TIMELINE_VIEWED;
	default:
		return null;
	}
}

export function getPeriscopeOpenedEvent(
	from: AMPLITUDE_PERISCOPE_EVENT_SOURCE,
	type: string
): AmplitudeEvent<{ from: AMPLITUDE_PERISCOPE_EVENT_SOURCE; type: string }> {
	return {
		data: {
			from,
			type
		},
		id: AMPLITUDE_EVENT.PERISCOPE_OPENED
	};
}
